<div class="flex layout-row wrap gap-sm">
  @for (ppv of propertySetValues$ | async; track ppv) {
    @if (ppv?.value?.primitive) {
      <mat-form-field appearance="fill">
        <mat-label>{{ ppv.key }}</mat-label>
        <input
          [name]="'pps-' + ppv.key"
          [ngModel]="ppv.value.primitive"
          matInput
          readonly
          type="text"
        />
      </mat-form-field>
    }
    @if (ppv?.value?.quantity) {
      <mat-form-field appearance="fill">
        <mat-label>{{ ppv.key }}</mat-label>
        <elder-quantity-input [name]="'pps-qty-' + ppv.key" [ngModel]="ppv.value.quantity" readonly>
        </elder-quantity-input>
      </mat-form-field>
    }
  }
</div>

@if (propertySet$ | async; as propSet) {
  <mat-form-field elderFormFieldLabel>
    <mat-label>{{ 'context.schema' | translate }}</mat-label>
    <input
      [ngModel]="propSet?.schema"
      matInput
      name="itemConfigType"
      placeholder="{{ 'context.schema' | translate }}"
      readonly
      type="text"
    />
  </mat-form-field>
}
